import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import nav from './modules/nav'
import user from './modules/user'
import { ElMessage } from "element-plus";
import {
  getCartGoodsTotal,
  getCartGoodsList,
} from "@/common/api.js";
const store = createStore({
  state:{
    //语言
    language:window.localStorage.getItem('languageStateSSR') || true,
    cartNumber:window.localStorage.getItem('cartNumber') || 0,//购物车里面的列表条数
  },
  modules: {
    nav,
    user,
  },
  mutations:{
    languageState(state,data){
      state.language=data
      window.localStorage.setItem('languageStateSSR',state.language)
    },
    setCartNumber(state,data){
      state.cartNumber=data
      window.localStorage.setItem('cartNumber',state.cartNumber)
    },
  },
  actions:{
    updateCartNumber(context){
      // getCartGoodsTotal({},res=>{
      //   if (res.data.header.code == 0) {
      //     let num=res.data.body.data.goodsNumber || 0
      //     console.log('num10086',num);
      //     context.commit('setCartNumber', num)
      //   }
      // })
      // getCartGoodsList({},res=>{
      //   if (res.data.header.code == 0) {
      //     let num=res.data.body.data.total || 0
      //     console.log('num10086',num);
      //     context.commit('setCartNumber', num)
      //   }
      // })
    },
  },
  plugins: [
    createPersistedState({
      key: 'state',
      paths: ['nav', 'user']
    }),
    createPersistedState({
      key: 'languageStateSSR',
      paths: ['language']
    }),
  ]
})
export default store